(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    function initAccordion(container) {
      if (container.dataset.init) return;
      container.dataset.init = 'true';

      const mode = container.dataset.mode || 'single';
      const items = Array.from(container.querySelectorAll('.pda__item'));

      function openItem(item) {
        const panel = item.querySelector('.pda__panel');
        item.classList.add('is-open');
        panel.style.height = panel.scrollHeight + 'px';

        panel.addEventListener(
          'transitionend',
          () => {
            if (item.classList.contains('is-open')) {
              panel.style.height = 'auto';
            }
          },
          { once: true }
        );
      }

      function closeItem(item) {
        const panel = item.querySelector('.pda__panel');
        panel.style.height = panel.scrollHeight + 'px';

        requestAnimationFrame(() => {
          panel.style.height = '0px';
          item.classList.remove('is-open');
        });
      }

      items.forEach((item) => {
        const trigger = item.querySelector('.pda__trigger');
        const panel = item.querySelector('.pda__panel');
        if (!trigger || !panel) return;

        // Estado inicial
        if (item.classList.contains('is-open')) {
          panel.style.height = panel.scrollHeight + 'px';
        }

        trigger.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');

          if (!isOpen && mode === 'single') {
            items.forEach((other) => {
              if (other !== item && other.classList.contains('is-open')) {
                closeItem(other);
              }
            });
          }

          isOpen ? closeItem(item) : openItem(item);
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-pda]').forEach(initAccordion);
    }

    document.addEventListener('DOMContentLoaded', initAll);

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', initAll);
      document.addEventListener('shopify:block:select', initAll);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-title"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    const btn = e.target.closest('.mobile-quick-add-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productCard = btn.closest('product-card');
    if (!productCard) return;

    const quickAddComponent = productCard.querySelector('quick-add-component');

    if (quickAddComponent && typeof quickAddComponent.handleClick === 'function') {
      quickAddComponent.handleClick(new MouseEvent('click', { cancelable: true, bubbles: true }));
    }
  });
  } catch(e) { console.error(e); }
})();

})();
